export type TextureVariant =
'blotch' |
'speckle' |
'bubbles' |
'scales' |
'streaks' |
'gradient' |
'grain' |
'wood' |
'diagonal' |
'cells' |
'weave';

export const textureRows: {id: TextureVariant;name: string;}[][] = [
[
{ id: 'blotch', name: 'Camo' },
{ id: 'speckle', name: 'Speckle' },
{ id: 'bubbles', name: 'Bubbles' },
{ id: 'scales', name: 'Scales' },
{ id: 'streaks', name: 'Brushed' },
{ id: 'gradient', name: 'Gradient' }],

[
{ id: 'grain', name: 'Sand' },
{ id: 'wood', name: 'Wood Grain' },
{ id: 'diagonal', name: 'Knurl' },
{ id: 'cells', name: 'Cells' },
{ id: 'weave', name: 'Weave' }]];
